import Modal from 'components/ui/Modal/Modal'
import NotDeleteBimLink from './NotDeleteBimLink'

const BimLinkDeleteModal = ({ isBimLinkInUse, isLoading, onClose }) => {
  if (!(isBimLinkInUse || isLoading)) return null

  return (
    <Modal
      modalClass="modal modal-new-articulo"
      containerChildrenClass="new-bimlink-container modal-delete-bimlink"
      onClose={onClose}
    >
      <NotDeleteBimLink
        tiposBimLink={isBimLinkInUse}
        isLoading={isLoading}
      />
    </Modal>
  )
}

export default BimLinkDeleteModal
